/**
 * Class to encapsulate fields needed for a breadcrumb entry.
 */
export class BreadCrumb {
  label: string;
  routerLink: string | null;
  sendSelectEvent?: boolean;
  command?: any;
  optional?: any;

  constructor(
    inLabel: string,
    inRouterLink: string | null,
    sendSelectEvent?: any,
    optional?: any
  ) {
    this.label = inLabel;
    this.routerLink = inRouterLink;
    this.sendSelectEvent = sendSelectEvent;
    this.optional = optional;
  }
}
